import React, { createContext } from 'react';
import { UseFloatingReturn } from '@floating-ui/react-dom';

interface TooltipContextProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refs: UseFloatingReturn['refs'];
  x: number | null;
  y: number | null;
  strategy: React.CSSProperties['position'];
}

export const TooltipContext = createContext<TooltipContextProps | null>(null);

export const useTooltipContext = () => {
  const context = React.useContext(TooltipContext);
  if (!context) {
    throw new Error(
      'Tooltip components must be used within a Tooltip provider',
    );
  }
  return context;
};
